import { Input } from 'baseui/input';
import { themedStyled } from 'common/styles/styletron.theme';

import CustomFormControl, {
  CustomFormControlProps,
} from './custom-form-control';
import { styles } from './styles';

interface Props
  extends Omit<
    CustomFormControlProps,
    'name' | 'overrides' | 'positive' | 'error' | 'children'
  > {
  value?: any;
  leftComponent?: React.ReactNode;
}

export default function ReadOnlyText(props: Props) {
  const {
    label,
    hideLabel,
    required,
    value = '',
    leftComponent,
    labelRightEnhancer,
  } = props;

  return (
    <CustomFormControl
      required={required}
      hideLabel={hideLabel}
      labelRightEnhancer={labelRightEnhancer}
      label={label}
      {...props}
    >
      <Container>
        {leftComponent}
        <Input
          value={value || '-'}
          overrides={{
            Input: {
              props: {
                readOnly: 'true',
              },
              style: styles.reset,
            },
            Root: {
              style: styles.reset,
            },
            InputContainer: {
              style: styles.reset,
            },
          }}
        />
      </Container>
    </CustomFormControl>
  );
}

const Container = themedStyled('div', {
  display: 'flex',
  marginTop: '4px',
});
